// @ts-nocheck
import * as z from 'zod';
export const isDefinedNonNullAny = (v) => v !== undefined && v !== null;
export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));
export const FeatureRequestStatusSchema = z.enum(['COMPLETED', 'IN_PROGRESS', 'OPEN', 'PLANNED', 'REJECTED']);
export const VotingModeSchema = z.enum(['COOKIE', 'OPEN', 'TRACKED']);
export function AdminFeatureRequestObjectSchema() {
    return z.object({
        __typename: z.literal('AdminFeatureRequestObject').optional(),
        createdAt: z.string().min(1),
        createdByExtRefId: z.string().nullish(),
        createdByName: z.string().nullish(),
        description: z.string().nullish(),
        hide: z.boolean(),
        id: z.string().min(1),
        projectId: z.string().min(1),
        status: FeatureRequestStatusSchema,
        title: z.string().min(1),
        updatedAt: z.string().min(1),
        upvoteCount: z.number()
    });
}
export function AuthResponseSchema() {
    return z.object({
        __typename: z.literal('AuthResponse').optional(),
        sessionId: z.string().nullish(),
        success: z.boolean()
    });
}
export function CreateFeatureRequestInputSchema() {
    return z.object({
        createdByExtRefId: z.string().nullish(),
        createdByName: z.string().nullish(),
        description: z.string().nullish(),
        extRefHmac: z.string().nullish(),
        projectId: z.string().min(1),
        title: z.string().min(1)
    });
}
export function CreateNoteInputSchema() {
    return z.object({
        body: z.string().min(1),
        featureRequestId: z.string().min(1)
    });
}
export function CreateProjectInputSchema() {
    return z.object({
        description: z.string().nullish(),
        name: z.string().min(1),
        tenantId: z.string().min(1),
        votingMode: VotingModeSchema.nullish()
    });
}
export function DetoxifyScoresObjectSchema() {
    return z.object({
        __typename: z.literal('DetoxifyScoresObject').optional(),
        identityAttack: z.number(),
        insult: z.number(),
        obscene: z.number(),
        severeToxicity: z.number(),
        threat: z.number(),
        toxicity: z.number()
    });
}
export function EmbedVerificationObjectSchema() {
    return z.object({
        __typename: z.literal('EmbedVerificationObject').optional(),
        projectId: z.string().min(1),
        projectName: z.string().min(1),
        status: z.string().min(1),
        votingMode: z.string().min(1)
    });
}
export function FeatureRequestObjectSchema() {
    return z.object({
        __typename: z.literal('FeatureRequestObject').optional(),
        createdAt: z.string().min(1),
        createdByExtRefId: z.string().nullish(),
        createdByName: z.string().nullish(),
        description: z.string().nullish(),
        hide: z.boolean(),
        id: z.string().min(1),
        isFlaggedByModeration: z.boolean(),
        isVoted: z.boolean(),
        projectId: z.string().min(1),
        status: FeatureRequestStatusSchema,
        title: z.string().min(1),
        updatedAt: z.string().min(1),
        upvoteCount: z.number()
    });
}
export function LoginDtoSchema() {
    return z.object({
        email: z.string().min(1),
        password: z.string().min(1)
    });
}
export function ModerationResultObjectSchema() {
    return z.object({
        __typename: z.literal('ModerationResultObject').optional(),
        detoxifyScores: z.lazy(() => DetoxifyScoresObjectSchema()),
        flaggedByDetoxify: z.boolean(),
        flaggedByGerman: z.boolean(),
        flaggedByProfanity: z.boolean(),
        germanLabel: z.string().min(1),
        germanScore: z.number(),
        toxic: z.boolean()
    });
}
export function NoteObjectSchema() {
    return z.object({
        __typename: z.literal('NoteObject').optional(),
        accountId: z.string().nullish(),
        body: z.string().min(1),
        createdAt: z.string().min(1),
        featureRequestId: z.string().min(1),
        id: z.string().min(1),
        updatedAt: z.string().min(1)
    });
}
export function ProjectObjectSchema() {
    return z.object({
        __typename: z.literal('ProjectObject').optional(),
        allowedOrigins: z.array(z.string().min(1)),
        createdAt: z.string().min(1),
        description: z.string().nullish(),
        hmacSecret: z.string().nullish(),
        id: z.string().min(1),
        name: z.string().min(1),
        status: z.string().min(1),
        tenantId: z.string().min(1),
        tenantName: z.string().nullish(),
        updatedAt: z.string().min(1),
        votingMode: z.string().min(1)
    });
}
export function RegisterDtoSchema() {
    return z.object({
        email: z.string().min(1),
        name: z.string().nullish(),
        password: z.string().min(1)
    });
}
export function ToggleHideFeatureRequestInputSchema() {
    return z.object({
        featureRequestId: z.string().min(1),
        hide: z.boolean()
    });
}
export function UpdateFeatureRequestInputSchema() {
    return z.object({
        description: z.string().nullish(),
        featureRequestId: z.string().min(1),
        title: z.string().nullish()
    });
}
export function UpdateFeatureRequestStatusInputSchema() {
    return z.object({
        featureRequestId: z.string().min(1),
        status: FeatureRequestStatusSchema
    });
}
export function UpdateProjectInputSchema() {
    return z.object({
        allowedOrigins: z.array(z.string().min(1)).nullish(),
        description: z.string().nullish(),
        name: z.string().nullish(),
        status: z.string().nullish(),
        votingMode: VotingModeSchema.nullish()
    });
}
export function UpvoteFeatureRequestInputSchema() {
    return z.object({
        extRefHmac: z.string().nullish(),
        extRefId: z.string().nullish(),
        featureRequestId: z.string().min(1)
    });
}
export function UserInfoSchema() {
    return z.object({
        __typename: z.literal('UserInfo').optional(),
        email: z.string().min(1),
        id: z.string().min(1),
        name: z.string().nullish(),
        role: z.string().min(1)
    });
}
export function VerifyEmbedInputSchema() {
    return z.object({
        embedOrigin: z.string().nullish(),
        pageHmac: z.string().min(1),
        projectId: z.string().min(1),
        timestamp: z.string().min(1)
    });
}
